import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CareCoordinatorComponent } from './care-coordinator.component';

const routes: Routes = [{ path: '', component:CareCoordinatorComponent  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CareCoordinatorRoutingModule { }
